export default __webpack_public_path__ + "roboto-v27-latin-italic.c8864b37568c1e60cc4437c78c60caba.woff";